/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { enumType } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

export enum SessionWalletCreateResponseApmDataTypeEnum {
  "apm" = "apm"
}

/**
 * Create session wallet response data type discriminator for apm onboarding
 */

export type SessionWalletCreateResponseApmDataType = t.TypeOf<
  typeof SessionWalletCreateResponseApmDataType
>;
export const SessionWalletCreateResponseApmDataType = enumType<
  SessionWalletCreateResponseApmDataTypeEnum
>(
  SessionWalletCreateResponseApmDataTypeEnum,
  "SessionWalletCreateResponseApmDataType"
);
